// @flow
import React from 'react';
import styled from 'styled-components';
import {
  //  Button, Footer, Box,
  Flex,
  Text,
} from '@sonyged/proc-ui';
import css from '@styled-system/css';

type Props = {
  total: number,
};
const DishesEaten = (props: Props) => (
  <Container>
    <Title>合計</Title>
    <Number>{props.total}</Number>
    <Title>まい</Title>
  </Container>
);

const Container = styled(Flex)(
  css({
    position: 'absolute',
    right: '10px',
    top: 0,
    alignItems: 'center',
  })
);

const Title = styled(Text)(
  css({
    fontSize: ['mobile.small', 'smallPC.small', 'largePC.small'],
  })
);

const Number = styled(Text)(
  css({
    display: 'inline-block',
    fontSize: ['mobile.large', 'smallPC.large', 'largePC.large'],
    marginX: '4px',
  })
);

export default DishesEaten;
